// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomeSelect_css-1qprcsu-option__To1E4{
    text-align: left;
}
.CustomeSelect_css-1vr111p-option__kDavT{
    text-align: left;
}
.CustomeSelect_css-1r4vtzz__bLw0F{
    width: 100% !important;
}
.CustomeSelect_css-48ayfv__tIlTr{
    width: 100% !important;
}

input{
    height: inherit
}

.CustomeSelect_react-select__option__oegGb{
    font-size: 80% !important;
}

.CustomeSelect_react-select__option1__Hb\\+Tv{
    font-size: 100% !important;
}

.CustomeSelect_react-select__menu-list__9SqYQ{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}
.CustomeSelect_ev_filter_icon__0Risi {
    background: #fff !important;
    color: #348393 !important;
}
.CustomeSelect_ev_filter_icon__0Risi:hover {
    background: #348393 !important;
    color: #fff !important;
}
.CustomeSelect_card__T5xkn.CustomeSelect_align-items-center__JkK0A.CustomeSelect_lp_br_bus__mQ6HJ {
    border: 1px solid lightgray;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/DigitalInstrumentCluster_Jupiter/CustomeSelect.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B","sourcesContent":[".css-1qprcsu-option{\n    text-align: left;\n}\n.css-1vr111p-option{\n    text-align: left;\n}\n.css-1r4vtzz{\n    width: 100% !important;\n}\n.css-48ayfv{\n    width: 100% !important;\n}\n\ninput{\n    height: inherit\n}\n\n.react-select__option{\n    font-size: 80% !important;\n}\n\n.react-select__option1{\n    font-size: 100% !important;\n}\n\n.react-select__menu-list{\n    max-height: 150px !important;\n    -webkit-overflow-scrolling:auto !important;\n}\n.ev_filter_icon {\n    background: #fff !important;\n    color: #348393 !important;\n}\n.ev_filter_icon:hover {\n    background: #348393 !important;\n    color: #fff !important;\n}\n.card.align-items-center.lp_br_bus {\n    border: 1px solid lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"css-1qprcsu-option": `CustomeSelect_css-1qprcsu-option__To1E4`,
	"css-1vr111p-option": `CustomeSelect_css-1vr111p-option__kDavT`,
	"css-1r4vtzz": `CustomeSelect_css-1r4vtzz__bLw0F`,
	"css-48ayfv": `CustomeSelect_css-48ayfv__tIlTr`,
	"react-select__option": `CustomeSelect_react-select__option__oegGb`,
	"react-select__option1": `CustomeSelect_react-select__option1__Hb+Tv`,
	"react-select__menu-list": `CustomeSelect_react-select__menu-list__9SqYQ`,
	"ev_filter_icon": `CustomeSelect_ev_filter_icon__0Risi`,
	"card": `CustomeSelect_card__T5xkn`,
	"align-items-center": `CustomeSelect_align-items-center__JkK0A`,
	"lp_br_bus": `CustomeSelect_lp_br_bus__mQ6HJ`
};
export default ___CSS_LOADER_EXPORT___;
